import React from 'react';
import LangMenu from './LangMenu';
import UserAvatar from './UserAvatar';
import ChainStationSelector from './ChainStationSelector';
import { Box, Hidden } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap : 'nowrap',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: theme.spacing(0.5, 0),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}));

const Header = () => {

  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <ChainStationSelector />
      <Hidden smDown={true}>
        <LangMenu />
        <UserAvatar />
      </Hidden>
    </Box>
  );
};


export default Header;
